import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

function AttendanceActionsMenu({ canUndoWholeLessonCancellation, canEditAllLessons, onAction }) {
  const { t: tr } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleAction = (action) => {
    setOpen(false);
    onAction(action);
  };

  return (
    <div className="attendance-page__actions">
      <button type="button" className="btn btn-outline-secondary" onClick={() => setOpen(!open)}>{tr("manage:lessonActions_0")}<span className="attendance-page__actions-chevron" aria-hidden="true">⌄</span>
      </button>
      {open && (
        <div className="attendance-page__actions-menu">
          <button type="button" onClick={() => handleAction("lesson-details")}>{tr("manage:editLessonDetails_1")}</button>
          {canEditAllLessons && (
            <button type="button" onClick={() => handleAction("class-details")}>{tr("manage:editAllLessonDetails")}</button>
          )}
          <button type="button" onClick={() => handleAction("absence-report")}>{tr("manage:reportAnAbsence_2")}</button>
          <button type="button" onClick={() => handleAction("lesson-cancellation")}>{tr("manage:cancelLesson_3")}</button>
          {canUndoWholeLessonCancellation && (
            <button type="button" onClick={() => handleAction("undo-cancellation")}>{tr("manage:undoCancellation_4")}</button>
          )}
          <button type="button" onClick={() => handleAction("student-list")}>{tr("manage:manageStudents_5")}</button>
        </div>
      )}
    </div>
  );
}

AttendanceActionsMenu.propTypes = {
  canUndoWholeLessonCancellation: PropTypes.bool,
  canEditAllLessons: PropTypes.bool,
  onAction: PropTypes.func.isRequired,
};

AttendanceActionsMenu.defaultProps = {
  canUndoWholeLessonCancellation: false,
  canEditAllLessons: false,
};

export default AttendanceActionsMenu;
